import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import bigKefRu from "@/assets/locales/ru.json";
import sravniDohodRu from "@/assets/locales/ru-sravni-dohod.json";

const translationsByServiceName = {
  big_kef: bigKefRu,
  sravni_dohod: sravniDohodRu,
} as const;

const activeTranslations =
  translationsByServiceName[
    __SERVICE_NAME__ as keyof typeof translationsByServiceName
  ] ?? translationsByServiceName.big_kef;

export const resources = {
  en: { translation: activeTranslations },
  ru: { translation: activeTranslations },
} as const;

export const defaultNS = "translation";

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "ru",
  defaultNS,
  ns: ["translation"],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
